"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _getDisplayName = require("b2b-components/utils/getDisplayName");
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _excluded = ["onCategoryClick", "onProductClick"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var withContainer = function withContainer(Component) {
  var WithContainer = function WithContainer(props) {
    var onCategoryClick = props.onCategoryClick,
      onProductClick = props.onProductClick,
      originalProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
    var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isMouseOver = _useState2[0],
      setIsMouseOver = _useState2[1];
    var handleProductClick = function handleProductClick(sku) {
      return function (e) {
        onProductClick(e, sku);
        e.preventDefault();
      };
    };
    var handleCategoryClick = function handleCategoryClick(url) {
      return function (e) {
        onCategoryClick(url);
        e.preventDefault();
      };
    };
    var handleMouseEnter = function handleMouseEnter() {
      setIsMouseOver(true);
    };
    var handleMouseLeave = function handleMouseLeave() {
      setIsMouseOver(false);
    };
    var injectedProps = {
      onCategoryClick: handleCategoryClick,
      onProductClick: handleProductClick,
      isMouseOver: isMouseOver,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave
    };
    return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, originalProps, injectedProps));
  };
  WithContainer.displayName = "withContainer(".concat((0, _getDisplayName.getDisplayName)(Component), ")");
  (0, _hoistNonReactStatics["default"])(WithContainer, Component);
  return WithContainer;
};
exports.withContainer = withContainer;